
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import { Spinner } from 'react-bootstrap';
import { Column } from 'primereact/column';

import { useStopBroadcastMutation } from '../../../../queries/broadcast';
import { STREAMS_TABLE_CONFIG } from '../../../../Constants/datatables';
import { useDataTableContext } from '../../../Contexts/DataTableContext';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import StreamPreview from './StreamPreview';
import { formatDateTime } from '../../../../utils/datetime';

const statusColor = {
    PUBLISHED: "warning",
    PROCESSING: "success",
    FINISHED: "danger",
}

function StreamsDataTable() {
    const { t } = useTranslation();
    const { totalRecords, loading, lazyParams, setLazyParams, data, onPage, onSort, onFilter, } = useDataTableContext();
    const openDialog = useSelector((state) => state.global.openDialog);
    const dispatch = useDispatch()

    const stopBroadcast = useStopBroadcastMutation()
    const [selectedItem, setSelectedItem] = useState({});

    useEffect(() => {
        setLazyParams(prev => ({
            ...prev, ...STREAMS_TABLE_CONFIG
        }))
    }, [])

    const previewHandler = (data) => {
        setSelectedItem(data)
        dispatch(toggleDialog("streamPreview"))
    }

    const stopStream = async (data) => {
        setSelectedItem(data)
        await stopBroadcast.mutateAsync({ id: data.id })
    }
    
    const typeBodyTemplate = (rowData) => {
        return (
            <div className='text-center'>
                <span className="text-center badge  bg-label-secondary text-capitalize">
                    {
                        rowData.type == "ONE_WAY"
                            ?
                            <i className="fas fa-long-arrow-alt-right me-2"></i>
                            :
                            <i className="fas fa-exchange-alt me-2"></i>
                    }
                    {rowData.type.replace(/_/g, ' ').toLowerCase()}
                </span>
            </div>
        );
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='d-flex align-items-center justify-content-end text-light '>
                {
                    rowData.status != "FINISHED" ?
                        (
                            (stopBroadcast.isLoading && selectedItem.id === rowData.id)
                                ?
                                <Spinner variant="primary" size='sm' as="span" animation="border" role="status" aria-hidden="true" />
                                :
                                <>
                                    <Tooltip target={`.stop-button-${rowData.id}`} showDelay={100} className="fs-8" />
                                    <button
                                        className={`btn btn-sm btn-icon stop-button-${rowData.id}`}
                                        data-pr-position="bottom"
                                        data-pr-tooltip={t('broadcast.tooltip_stop_stream')}
                                        onClick={() => stopStream(rowData)} >
                                        <i className="fas fa-stop-circle  text-light fs-6"></i>
                                    </button>
                                </>)
                        :
                        ""
                }

                <Tooltip target={`.preview-button-${rowData.id}`} showDelay={100} className="fs-8" />
                <button
                    className={`btn btn-sm btn-icon preview-button-${rowData.id}`}
                    data-pr-position="bottom"
                    data-pr-tooltip={t('broadcast.tooltip_stream_preview')}
                    onClick={() => previewHandler(rowData)} >
                    <i className="fa-solid fa-eye  text-light fs-6"></i>
                </button>
            </div>
        )
    }

    const statusBodyTemplate = (rowData) => {
        return (
            <div className='text-center'>
                <span className={`text-center badge bg-label-${statusColor?.[rowData.status]} `}>
                    {rowData.status.toLowerCase()}
                </span>
            </div>
        );
    }

    return (
        <div className='table-responsive text-nowrap '>
            <DataTable value={data?.streams} lazy responsiveLayout="scroll" dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[15, 25, 50, 100]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} loading={loading} className="table"
            >
                <Column field="name" header={t('table.name')} className='text-center' sortable />
                <Column field="type" className='text-center' header={t('table.type')} body={typeBodyTemplate} />
                <Column field="status" header={t('table.status')} className='text-center' sortable body={statusBodyTemplate} />
                <Column field="created_at" header={t('broadcast.col_created_date')} className='text-center' sortable
                    body={(r) => formatDateTime(r.created_at)} />
                <Column field="" header="" className='text-center ' body={actionBodyTemplate} />
            </DataTable>

            {
                openDialog.streamPreview ? <StreamPreview streamInfo={selectedItem} /> : <></>
            }
        </div>

    )
}

export default StreamsDataTable